import { SeraTableCol } from '../../shared/ui/sera-table/models/SeraTableCol';
import { analysisFormTranslationKeys } from '../../analysis/models/AnalysisForm';
import { analysisStatusTranslationKeys } from '../../analysis/models/AnalysisStatus';
import { trafficLightColorTranslationKeys } from '../../analysis/models/criterions/TrafficLightColor';
import { ApprovalViaGdms } from '../../analysis/models/ApprovalViaGdms';
import { AnalysisType } from '../../analysis/models/AnalysisType';
import { TVGStatus } from '../../analysis/models/TVGStatus';

const ALL_USER_PREFS_SEARCH_COLUMNS: SeraTableCol[] = [
    {
        field: 'workplaceNumber',
        userPrefsField: 'WORKPLACE_NUMBER',
        header: 'PAGE.ANALYSISEARCH.HEADER.WORKPLACE_NUMBER.LBL'
    },
    {
        field: 'description',
        userPrefsField: 'DESCRIPTION_SHORT',
        header: 'PAGE.ANALYSISEARCH.HEADER.DESCRIPTION_SHORT.LBL'
    },
    {
        field: 'plantCode',
        userPrefsField: 'PLANT',
        header: 'PAGE.ANALYSISEARCH.HEADER.PLANT.LBL'
    },
    {
        field: 'plantCCDCostCenterCodes',
        userPrefsField: 'PLANT_CC_DC',
        header: 'PAGE.ANALYSISEARCH.HEADER.CCDC.LBL',
        maxWidth: 320,
        type: 'array'
    },
    {
        field: 'analysisForm',
        userPrefsField: 'ANALYSIS_FORM',
        header: 'PAGE.ANALYSISEARCH.HEADER.FORM.LBL',
        type: 'enum',
        enum: analysisFormTranslationKeys
    },
    {
        field: 'sectionAreaCode',
        userPrefsField: 'SECTION_AREA',
        header: 'PAGE.ANALYSISEARCH.HEADER.FOREMAN_AREA.LBL'
    },
    {
        field: 'technologyCode',
        userPrefsField: 'TECHNOLOGY',
        header: 'PAGE.ANALYSISEARCH.HEADER.TECHNOLOGY.LBL'
    },
    {
        field: 'status',
        userPrefsField: 'STATUS',
        header: 'PAGE.ANALYSISEARCH.HEADER.STATUS.LBL',
        type: 'enum',
        enum: analysisStatusTranslationKeys
    },
    {
        field: 'cycleCode',
        userPrefsField: 'CYCLE',
        header: 'PAGE.ANALYSISEARCH.HEADER.CYCLE.LBL'
    },
    {
        field: 'shiValue',
        userPrefsField: 'TOTAL_SHI',
        header: 'PAGE.ANALYSISEARCH.HEADER.SHI.LBL',
        type: 'shiValue',
        maxWidth: 64
    },
    {
        field: 'color',
        userPrefsField: 'TOTAL_COLOR',
        header: 'PAGE.ANALYSISEARCH.HEADER.TOTAL_COLOR.LBL',
        type: 'enum',
        enum: trafficLightColorTranslationKeys
    },
    {
        field: 'mm01',
        userPrefsField: 'mm01',
        header: 'PAGE.ANALYSISEARCH.CR01.LBL',
        type: 'criterionValue',
        maxWidth: 64
    },
    {
        field: 'mm02',
        userPrefsField: 'mm02',
        header: 'PAGE.ANALYSISEARCH.CR02.LBL',
        type: 'criterionValue',
        maxWidth: 64
    },
    {
        field: 'mm03',
        userPrefsField: 'mm03',
        header: 'PAGE.ANALYSISEARCH.CR03.LBL',
        type: 'criterionValue',
        maxWidth: 64
    },
    {
        field: 'mm04',
        userPrefsField: 'mm04',
        header: 'PAGE.ANALYSISEARCH.CR04.LBL',
        type: 'criterionValue',
        maxWidth: 64
    },
    {
        field: 'mm05',
        userPrefsField: 'mm05',
        header: 'PAGE.ANALYSISEARCH.CR05.LBL',
        type: 'criterionValue',
        maxWidth: 64
    },
    {
        field: 'mm06',
        userPrefsField: 'mm06',
        header: 'PAGE.ANALYSISEARCH.CR06.LBL',
        type: 'criterionValue',
        maxWidth: 64
    },
    {
        field: 'mm07',
        userPrefsField: 'mm07',
        header: 'PAGE.ANALYSISEARCH.CR07.LBL',
        type: 'criterionValue',
        maxWidth: 64
    },
    {
        field: 'mm08',
        userPrefsField: 'mm08',
        header: 'PAGE.ANALYSISEARCH.CR08.LBL',
        type: 'criterionValue',
        maxWidth: 64
    },
    {
        field: 'mm09',
        userPrefsField: 'mm09',
        header: 'PAGE.ANALYSISEARCH.CR09.LBL',
        type: 'criterionValue',
        maxWidth: 64
    },
    {
        field: 'mm10',
        userPrefsField: 'mm10',
        header: 'PAGE.ANALYSISEARCH.CR10.LBL',
        type: 'criterionValue',
        maxWidth: 64
    },
    {
        field: 'mm11',
        userPrefsField: 'mm11',
        header: 'PAGE.ANALYSISEARCH.CR11.LBL',
        type: 'criterionValue',
        maxWidth: 64
    },
    {
        field: 'mm12',
        userPrefsField: 'mm12',
        header: 'PAGE.ANALYSISEARCH.CR12.LBL',
        type: 'criterionValue',
        maxWidth: 64
    },
    {
        field: 'mm13',
        userPrefsField: 'mm13',
        header: 'PAGE.ANALYSISEARCH.CR13.LBL',
        type: 'criterionValue',
        maxWidth: 64
    },
    {
        field: 'approvalViaGdms',
        userPrefsField: 'APPROVAL_PROCESS',
        header: 'PAGE.ANALYSISEARCH.HEADER.APPROVAL_PROCESS.LBL',
        type: 'enum',
        enum: ApprovalViaGdms,
        customParams: { capitalize: true }
    },
    {
        field: 'analysisType',
        userPrefsField: 'ANALYSIS_TYPE',
        header: 'PAGE.ANALYSISEARCH.HEADER.TYPE.LBL',
        type: 'enum',
        enum: AnalysisType
    },
    {
        field: 'numberIdenticalWorkPlace',
        userPrefsField: 'NUMBER_IDENTICAL_WORKPLACE',
        header: 'PAGE.ANALYSISEARCH.HEADER.N_IDENTICAL_WORKPLACE.LBL'
    },
    {
        field: 'mmeTypeCodeList',
        userPrefsField: 'MME_TYPES',
        header: 'PAGE.ANALYSISEARCH.HEADER.MME_TYPES.LBL'
    },
    {
        field: 'validTo',
        userPrefsField: 'VALID_TO',
        header: 'PAGE.ANALYSISEARCH.HEADER.VALID_TO.LBL',
        type: 'date',
        customParams: { format: 'dd/MM/yyyy' }
    },
    {
        field: 'maxVersion',
        userPrefsField: 'HIGHEST_VERSION_NUMBER',
        header: 'PAGE.ANALYSISEARCH.HEADER.HIGHEST_VERSION.LBL'
    },
    {
        field: 'derivativeCode',
        userPrefsField: 'DERIVATIVE',
        header: 'PAGE.ANALYSISEARCH.HEADER.DERIVATIVE.LBL'
    },
    {
        field: 'section1',
        userPrefsField: 'PHYSICAL_STRESS',
        header: 'PAGE.ANALYSISEARCH.HEADER.PHYSICAL_STRESS.LBL',
        type: 'criterionValue',
        maxWidth: 92
    },
    {
        field: 'maternityPregnancy',
        userPrefsField: 'EXPECTANT_MOTHERS',
        header: 'PAGE.ANALYSISEARCH.HEADER.EXPECTANT_MOTHERS.LBL',
        type: 'colorField'
    },
    {
        field: 'maternityStill',
        userPrefsField: 'BREASTFEEDING_MOTHERS',
        header: 'PAGE.ANALYSISEARCH.HEADER.BREASTFEEDING_MOTHERS.LBL',
        type: 'colorField'
    },
    {
        field: 'tvgStatus',
        userPrefsField: 'TVG_STATUS',
        header: 'PAGE.ANALYSISEARCH.HEADER.MAPP_TVG_STATUS.LBL',
        enum: TVGStatus,
        customParams: { capitalize: true }
    },
    {
        field: 'completenessFactor',
        userPrefsField: 'COMPLETENESS_FACTOR',
        header: 'PAGE.ANALYSISEARCH.HEADER.MUA_COMPLETENESS.LBL'
    },
    {
        field: 'workedOnDate',
        userPrefsField: 'LAST_EDIT',
        header: 'PAGE.ANALYSISEARCH.HEADER.LAST_EDIT.LBL',
        type: 'date'
    },
    {
        field: 'position',
        userPrefsField: 'POSITION',
        header: 'PAGE.ANALYSISEARCH.HEADER.POSITION.LBL'
    },
    {
        field: 'reviewedOnDate',
        userPrefsField: 'LAST_ANNUAL_REVIEW_ON',
        header: 'PAGE.ANALYSISEARCH.HEADER.LAST_ANNUAL_REVIEW_ON.LBL',
        type: 'date',
        customParams: { format: 'dd/MM/yyyy' }
    }
];

export function getSortedSearchResultColumns(userPrefsCols: string): SeraTableCol[] {
    const userPrefsColsArray = getUserPrefsColsArray(userPrefsCols);
    const dataCols = ALL_USER_PREFS_SEARCH_COLUMNS.filter(col => col.userPrefsField && userPrefsColsArray.includes(col.userPrefsField.toLowerCase()));

    return [...dataCols].sort((a, b) => {
        const aField = a.userPrefsField!.toLowerCase();
        const bField = b.userPrefsField!.toLowerCase();

        return userPrefsColsArray.indexOf(aField) - userPrefsColsArray.indexOf(bField);
    });
}

function getUserPrefsColsArray(userPrefsCols: string): string[] {
    return userPrefsCols
        .split(' ')
        .map(col => col.trim())
        .filter(Boolean)
        .map(col => col.toLowerCase());
}
